"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStaticProps = exports.getStaticPaths = exports.getUrlPattern = void 0;
const utils_enums_environment_1 = require("@gcloud-npm/utils.enums.environment");
const redux_saga_1 = require("redux-saga");
const get_orion_info_1 = __importDefault(require("./utils/get-orion-info"));
const get_seo_info_1 = __importDefault(require("./utils/get-seo-info"));
const get_header_footer_info_1 = __importDefault(require("./utils/get-header-footer-info"));
const getUrlPattern = ({ pathname, group, fibre, deepNumber }) => {
    const URL_PATTERN = {
        2: `/${group}`,
        3: `/${group}/${pathname}`,
        4: `/${group}/${pathname}/${fibre}`,
    };
    return URL_PATTERN[deepNumber];
};
exports.getUrlPattern = getUrlPattern;
// Definimos las posibles urls
function getStaticPaths(creativityName, deepNumber = 1, altPaths = []) {
    return __awaiter(this, void 0, void 0, function* () {
        // Miramos primero si tirar de altPath (array de strings con las urls), sino usaremos custo
        if (Array.isArray(altPaths) && altPaths.length > 0) {
            return {
                paths: altPaths,
                fallback: false,
            };
        }
        let getByName = yield Promise.all([Promise.resolve().then(() => __importStar(require("@gcloud-npm/adabyron.custo.get-by-name")))]);
        getByName = getByName[0].default;
        const environment = (0, utils_enums_environment_1.findOutEnvByEnvName)();
        const paths = yield getByName({
            name: creativityName,
            context: { environment },
            build: true,
            kind: "creativity",
        });
        let pathsPathnames = paths.data.filter((p) => p.notBuild !== true);
        pathsPathnames = pathsPathnames.map((p) => p.pathname);
        // Debemos pillar solo las urls con profundidad deepNumber
        return {
            paths: pathsPathnames.filter((p) => p.split("/").length === deepNumber),
            fallback: false,
        };
    });
}
exports.getStaticPaths = getStaticPaths;
const getStaticProps = (data, creativityName, deepNumber, altPage) => __awaiter(void 0, void 0, void 0, function* () {
    const { store, params } = data;
    const context = store.getState().main.context;
    // Obtener información de Orion o Custo según la opción useCusto
    const promises = [];
    let currentPathname = null;
    let orionAlias = null;
    let orionInfo = null;
    let layoutInfo = "ficha";
    let custoPromises = [];
    // ORION INFO
    const { default: getByName } = yield Promise.resolve().then(() => __importStar(require("@gcloud-npm/adabyron.custo.get-by-name")));
    // Vemos si tirar de custo para coger la info o la pasamos nosotros
    let currentPage = null;
    if (altPage && altPage.pathname) {
        currentPage = altPage;
    }
    else {
        let pageIndex = yield getByName({
            name: creativityName,
            context: context,
            build: true,
            kind: "creativity",
        });
        pageIndex = pageIndex.data;
        // Sacamos el alias para orion desde parametros, asi como la url para las cabeceras y footer
        currentPage = pageIndex.find((p) => p.pathname === (0, exports.getUrlPattern)(Object.assign(Object.assign({}, params), { deepNumber })));
    }
    orionAlias = currentPage.orionAlias;
    // currentPathname = `/particulares${otherPathName}${currentPage.pathname}`;
    currentPathname = currentPage.headerLocation;
    if (currentPage.layout) {
        layoutInfo = currentPage.layout;
    }
    if (orionAlias) {
        orionInfo = yield (0, get_orion_info_1.default)(context, orionAlias);
    }
    // Get custo info
    if (currentPage.custoActivitiesIds &&
        Array.isArray(currentPage.custoActivitiesIds) &&
        currentPage.custoActivitiesIds.length > 0) {
        custoPromises = currentPage.custoActivitiesIds.map((activity) => {
            return getByName({
                name: activity,
                context: context,
                build: true,
                kind: "activity",
            });
        });
    }
    // SEO
    promises.push((0, get_seo_info_1.default)(context, currentPage));
    // HEADER FOOTER INFO
    promises.push((0, get_header_footer_info_1.default)(store, context, currentPathname));
    const promisesData = yield Promise.all([...promises, ...custoPromises]);
    const promisesLength = promises.length;
    const custo = [...promisesData].splice(promisesLength, custoPromises.length);
    const basicInfo = [...promisesData].splice(0, promisesLength);
    const [seoInfo, headerFooterInfo] = basicInfo;
    const { headerProps, breadcrumbsProps, footerProps } = headerFooterInfo;
    const custoInfo = {};
    custo.forEach((custoResponse) => {
        const { activityName } = custoResponse;
        custoInfo[activityName] = custoResponse;
    });
    store.dispatch(redux_saga_1.END);
    yield store.sagaTask.toPromise();
    return {
        props: {
            seoInfo,
            headerProps,
            breadcrumbsProps,
            footerProps,
            custoInfo,
            layoutInfo,
            // orion
            orionInfo,
            orionAlias,
        },
    };
});
exports.getStaticProps = getStaticProps;
exports.default = exports.getStaticProps;
//# sourceMappingURL=index.js.map